import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  error: {
    color: 'red',
  },
});

export default useStyles;
